export const config = {
   ajaxURL: '../ajax.php'
}